import { ComponentProps } from 'react';
import { InboxUtilsHooks } from '@frontend/inbox-api-utils';
import { useThreadHeaderContext } from '@frontend/thread-header-context';
import { DepartmentSelectorState, DepartmentSelector as StandaloneDepartmentSelector } from './department-selector';
import { useDepartmentSelector } from './use-department-selector';

type DepartmentSelectorProps = Omit<
  ComponentProps<typeof StandaloneDepartmentSelector>,
  keyof DepartmentSelectorState | 'onSelectDepartment' | 'variant'
>;

export const DepartmentSelectorAtom = (rest: DepartmentSelectorProps) => {
  const {
    groupId,
    personPhone,
    locationPhone,
    onLocationPhoneChange: onOutboundPhoneChange,
    variant,
  } = useThreadHeaderContext();
  const { getDataFromLocationPhone } = InboxUtilsHooks.useDepartmentLocationPhoneMappings();

  const departmentId = locationPhone?.locationPhone
    ? getDataFromLocationPhone(locationPhone?.locationPhone)?.departmentId
    : undefined;

  const departmentSelectorState = useDepartmentSelector({
    groupId,
    departmentId,
    alwaysShow: false,
    personPhone,
  });

  if (!onOutboundPhoneChange || !departmentId) return null;

  return (
    <StandaloneDepartmentSelector
      {...departmentSelectorState}
      onSelectDepartment={onOutboundPhoneChange}
      variant={variant}
      {...rest}
    />
  );
};
